import { createSlice } from "@reduxjs/toolkit";
import {
  addTeamLead,
  getAssignedAgents,
  getTeamLead,
  unassignAgent,
} from "./teamLeadThunk";

const initialState = {
  isLoading: false,
  error: null,
  teamLeadData: null,
  currentTeamLead: null,
};

export const TeamLeadSlice = createSlice({
  name: "team_lead",
  initialState,
  reducers: {
    currentTeamLeadData: (state, action) => {
      const { teamlead } = action.payload;
      state.currentTeamLead = teamlead;
      console.log(" state.currentTeamLead : ", state.currentTeamLead);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTeamLead.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addTeamLead.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addTeamLead.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getAssignedAgents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAssignedAgents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.teamLeadData = action.payload;
        console.log("data##################", action.payload);
        console.log(state.teamLeadData, "its data");
      })
      .addCase(getAssignedAgents.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getTeamLead.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getTeamLead.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentTeamLead = action.payload;
      })
      .addCase(getTeamLead.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(unassignAgent.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(unassignAgent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = action.payload;
      })
      .addCase(unassignAgent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});
export const { currentTeamLeadData } = TeamLeadSlice.actions;

export default TeamLeadSlice.reducer;
